import { Stepper } from "@mantine/core";
import { useState, useEffect } from "react";
import { useUser } from "./Context";
import { IconEye } from "@tabler/icons-react";

export default function DisplayWorkflow({ os }) {
  const { isratp } = useUser();
  const [active, setActive] = useState(0);

  const workflow = (os.workflow || []).slice().sort((a, b) => a.order_index - b.order_index);

  useEffect(() => {
    const firstPendingIdx = workflow.findIndex((w) => w.role === "signer" && !w.signed);
    if (firstPendingIdx === -1) setActive(workflow.length);
    else setActive(firstPendingIdx);
  }, [os, workflow]);

  const stepColor = isratp ? "#00aa91" : "#ff7e2e";

  return (
    <Stepper color={stepColor} active={active}>
      {workflow.map((w, idx) => {
        const isViewer = w.role === "viewer";

        const prevBlocking = workflow
          .filter((x) => x.order_index < w.order_index && x.role === "signer")
          .some((x) => !x.signed);

        const prevRejected = workflow
          .filter((x) => x.order_index < w.order_index && x.role === "signer")
          .some((x) => x.status === "rejected");

        let description = "";

        if (w.status === "rejected") {
          description = "A refusé";
        } else if (w.signed) {
          description = w.signed_at
            ? `Signé le ${new Date(w.signed_at).toLocaleString("fr-FR", {
                timeZone: "Europe/Paris",
                day: "2-digit",
                month: "2-digit",
                year: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              })}`
            : "Signé";
        } else if (prevRejected) {
          description = "Refusé par le signataire précédent";
        } else if (isViewer) {
          description = "Lecteur (non signataire)";
        } else if (prevBlocking) {
          description = "En attente d'étapes précédentes";
        } else {
          description = "En attente de signature";
        }

        return (
          <Stepper.Step
            key={idx}
            label={w.email}
            description={description}
            completedIcon={isViewer ? <IconEye size={20} /> : undefined}
            color={w.status === "rejected" || prevRejected ? "red" : undefined}
          />
        );
      })}
      <Stepper.Completed />
    </Stepper>
  );
}
